import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './pages/ProtectedRoute';
import { useEffect } from 'react';
import ScrollToTop from './pages/ScrollToTop';

import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import JobSearch from './pages/JobSearch';
import JobDetail from './pages/JobDetail';
import MyApplications from './pages/MyApplications';
import EmployerJobs from './pages/EmployerJobs';
import EmployerApplicants from './pages/EmployerApplicants';
import Profile from './pages/Profile';
import Navbar from './pages/Navbar';
import Footer from './pages/Footer';
import JobDetailsList from "./pages/JobDetailsList";
import AdminPanel from './pages/AdminPanel';
import CompanyProfile from './pages/CompanyProfile';
import ResumeBuilder from './pages/ResumeBuilder';
import ForgotPassword from './pages/ForgotPassword';
import AgentDashboard from './pages/AgentDashboard';
import AgentCandidates from './pages/AgentCandidates';
import AgentEmployers from './pages/AgentEmployers';
import AgentJobsList from './pages/Agentjobslist';
import AgentFollowUps from './pages/AgentFollowUps';
import AgentInterviews from './pages/AgentInterviews';
import AgentReports from './pages/AgentReports';
import AgentSettings from './pages/AgentSettings';
import AgentCommissions from './pages/AgentCommissions';
import DiscoveryModel from './pages/DiscoveryModel';
import SavedJobs from './pages/SavedJobs';
import OAuthCallback from './pages/OAuthCallback';
import JobCard from './pages/JobCard';
import EmployerTeam from './pages/EmployerTeam';
import AcceptInvite from './pages/AcceptInvite';
import EmployerNotificationSettings from './pages/EmployerNotificationSettings';
import EmployerHiringPreferences from './pages/EmployerHiringPreferences';
import EmployerBilling from './pages/EmployerBilling';
import EmployerInterviews from './pages/EmployerInterviews';
import EmployerOffers from './pages/EmployerOffers';
import OfferRespond from './pages/OfferRespond';
import EmployerPipeline from './pages/EmployerPipeline';
import EmployerDashboard from './pages/EmployerDashboard';
import CompanyVerification from './pages/CompanyVerification';
import EmployerOfferDetails from "./pages/EmployerOfferDetails";
import HiringAnalytics from './pages/HiringAnalytics';
import JobAnalytics from './pages/JobAnlytics';
import CandidateAnalytics from './pages/CandidateAnalytics';
import EmployerCandidateDatabase from './pages/EmployerCandidateDatabase'; // match your actual path/casing
import EmployerCandidateProfile from './pages/EmployerCandidateProfile';
import EmployerReports from './pages/EmployerReports';
import FraudFlags from './pages/FraudFlags';
import EmployerPlacements from './pages/EmployerPlacements';
import { captureAttributionFromUrl } from './utils/Attribution';

import EmployerRetentions from './pages/EmployerRetentions'; 
import AgentSubscriptions from './pages/AgentSubscriptions';
import AgentExpiringPlans from './pages/AgentExpiringPlans';
import AgentEmployerDetail from './pages/AgentEmployerDetail';
import UpdateBanner from './components/UpdateBanner';

import usePwaLaunchTracking from './hooks/usePwaLaunchTracking';
import EmployerDatabase from './pages/EmployeeDatabase';
import EmployerHelpSupport from './pages/EmployerHelpSupport';
import JobSeekerHelpSupport from './pages/JobSeekerHelpSupport';
import AgentVerification from './pages/AgentVerification';
import AgentVerificationDetail from './pages/AgentVerificationDetail';
import AdminVerification from './pages/AdminVerification';
import AdminVerificationDetail from './pages/AdminVerificationDetail';
import BusinessesPage from './pages/BusinessesPage';
import AgentSupportTicketsPanel from './pages/AgentSupportTicketsPanel';

import CompanyPublicProfile from './pages/CompanyPublicProfile';
import JobOrLocation from './pages/JobOrLocation';
import ComboPage from './pages/ComboPage';
import AggregatedJobList from './pages/AggregatedJobList';
import AggregatedJobDetail from './pages/AggregatedJobDetail';
import AgentAggregatedApplications from './pages/AgentAggregatedApplications';
import AgentPostJob from './pages/AgentPostJob';
import AgentBusinesses from './pages/AgentBusinesses';
import BusinessFollowUpsPage from './pages/BusinessFollowUpsPage'; // ✅ correct
import JobNews from './pages/JobNews';
import JobNewsDetail from './pages/JobNewsDetail';   // adjust the path
import CompaniesList from './pages/CompaniesList';
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DeleteAccount from "./pages/DeleteAccount";
import RequestAccountDeletion from './pages/RequestAccountDeletion';
import AdminEnterpriseInquiries from './pages/AdminEnterpriseInquiries';
import ContactPage from './pages/ContactPage';
import AboutUs from './pages/AboutUs';
import JobSeekers from './pages/JobSeekers';
import Employers from './pages/Employers';
import AiJobMatching from './pages/AiJobMatching';
import Pricing from './pages/Pricing';
import CareerResources from './pages/CareerResources';
import { seoLandingRoutes } from './pages/SeoLanding';
import GuestMockInterview from './pages/GuestMockInterview';
import GuestInterviewQA from './pages/GuestInterviewQA';
import { seoHubRoutes } from './pages/SeoHubs';
import WhyPlanB from './pages/WhyPlanB';

const InterviewQARoute = () =>
  localStorage.getItem('token')
    ? <ProtectedRoute allowedRoles={['job_seeker']}><ResumeBuilder key="questions" view="questions" /></ProtectedRoute>
    : <GuestInterviewQA />;

const MockInterviewRoute = () =>
  localStorage.getItem('token')
    ? <ProtectedRoute allowedRoles={['job_seeker']}><ResumeBuilder key="mock" view="mock" /></ProtectedRoute>
    : <GuestMockInterview />;

   function App() {
   useEffect(() => {
    captureAttributionFromUrl();
  }, []);

   usePwaLaunchTracking();

  return (
    <BrowserRouter>
       <UpdateBanner />
      <ScrollToTop />
<Routes>
        {/* ---------------- Public routes ---------------- */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/jobs" element={<JobSearch />} />
        {/* <Route path="/jobs/:id" element={<JobDetail />} /> */}
        <Route path="/jobs/:id" element={<JobOrLocation />} />
        <Route path="/company/:slug" element={<CompanyPublicProfile />} />
        <Route path="/job-details" element={<JobDetailsList />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/oauth/callback" element={<OAuthCallback />} />
        <Route path="/recruiter/accept-invite" element={<AcceptInvite />} />
        <Route path="/offers/respond/:token" element={<OfferRespond />} />
        <Route path="/navbar" element={<Navbar />} />
        <Route path="/footer" element={<Footer />} />
        <Route path="/jobcard" element={<JobCard />} />
        <Route path="/jobs/:location/:category" element={<ComboPage />} />
        <Route path="/aggregated-jobs" element={<AggregatedJobList />} />
        <Route path="/aggregated-jobs/:id" element={<AggregatedJobDetail />} />
        <Route path="/news" element={<JobNews />} />
        <Route path="/news/:id" element={<JobNewsDetail />} />
        <Route path="/companies" element={<CompaniesList />} />
        <Route path="/why-planb-jobs" element={<WhyPlanB />} />
        <Route path="/job-seekers" element={<JobSeekers />} />
<Route path="/employers" element={<Employers />} />
<Route path="/ai-job-matching" element={<AiJobMatching />} />
<Route path="/pricing" element={<Pricing />} />
<Route path="/career-resources" element={<CareerResources />} />

{/* your Home page links to /employer/pricing, which has no route yet */}
<Route path="/employer/pricing" element={<Navigate to="/pricing" replace />} />
{seoLandingRoutes}
   {seoHubRoutes}
       <Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/delete-account" element={<DeleteAccount />} />
<Route path="/contact-us" element={<ContactPage />} />
<Route path="/contact" element={<ContactPage />} />
<Route path="/about-us" element={<AboutUs />} />
<Route path="/about" element={<AboutUs />} />
<Route
  path="/account/delete"
  element={<ProtectedRoute allowedRoles={['job_seeker', 'employer', 'recruiter']}><RequestAccountDeletion /></ProtectedRoute>}
/>
        {/* ---------------- Job seeker routes ---------------- */}
        <Route
          path="/dashboard"
          element={<ProtectedRoute allowedRoles={['job_seeker']}><JobSearch /></ProtectedRoute>}
        />
        <Route
          path="/my-applications"
          element={<ProtectedRoute allowedRoles={['job_seeker']}><MyApplications /></ProtectedRoute>}
        />
        <Route
          path="/profile"
          element={<ProtectedRoute allowedRoles={['job_seeker']}><Profile /></ProtectedRoute>}
        />
        <Route
          path="/resume-builder"
          element={<ProtectedRoute allowedRoles={['job_seeker']}><ResumeBuilder view="resume" /></ProtectedRoute>}
        />
        <Route
          path="/resume-score"
          element={<ProtectedRoute allowedRoles={['job_seeker']}><ResumeBuilder view="ats" /></ProtectedRoute>}
        />
        <Route
          path="/interview-questions"
          element={<InterviewQARoute />}
        />
        <Route
          path="/mock-interview"
          element={<MockInterviewRoute />}
        />
        <Route
          path="/saved-jobs"
          element={<ProtectedRoute allowedRoles={['job_seeker']}><SavedJobs /></ProtectedRoute>}
        />
        <Route
          path="/discover"
          element={<ProtectedRoute allowedRoles={['job_seeker']}><DiscoveryModel /></ProtectedRoute>}
        />
        <Route
  path="/helpsupport"
  element={<ProtectedRoute allowedRoles={['job_seeker']}><JobSeekerHelpSupport /></ProtectedRoute>}
/>


        {/* ---------------- Employer routes ---------------- */}
       <Route
  path="/employer/jobs"
  element={<ProtectedRoute allowedRoles={['employer', 'recruiter']}><EmployerJobs /></ProtectedRoute>}
/>
        <Route
          path="/employer/jobs/:jobId/applicants"
          element={<ProtectedRoute allowedRoles={['employer']}><EmployerApplicants /></ProtectedRoute>}
        />
        <Route
          path="/company-profile"
          element={<ProtectedRoute allowedRoles={['employer']}><CompanyProfile /></ProtectedRoute>}
        />
        <Route
          path="/employer/team"
          element={<ProtectedRoute allowedRoles={['employer']}><EmployerTeam /></ProtectedRoute>}
        />
        <Route
          path="/employer/settings/notifications"
          element={<ProtectedRoute allowedRoles={['employer']}><EmployerNotificationSettings /></ProtectedRoute>}
        />
        <Route
          path="/employer/settings/hiring"
          element={<ProtectedRoute allowedRoles={['employer']}><EmployerHiringPreferences /></ProtectedRoute>}
        />
        <Route
          path="/employer/settings/billing"
          element={<ProtectedRoute allowedRoles={['employer']}><EmployerBilling /></ProtectedRoute>}
        />
        <Route
          path="/employer/interviews"
          element={<ProtectedRoute allowedRoles={['employer']}><EmployerInterviews /></ProtectedRoute>}
        />
        <Route
          path="/employer/offers"
          element={<ProtectedRoute allowedRoles={['employer']}><EmployerOffers /></ProtectedRoute>}
        />
        <Route
          path="/employer/offers/:id"
          element={<ProtectedRoute allowedRoles={['employer']}><EmployerOfferDetails /></ProtectedRoute>}
        />
        <Route
          path="/employer/pipeline"
          element={<ProtectedRoute allowedRoles={['employer']}><EmployerPipeline /></ProtectedRoute>}
        />
        <Route
          path="/employer/dashboard"
          element={<ProtectedRoute allowedRoles={['employer']}><EmployerDashboard /></ProtectedRoute>}
        />
        <Route
          path="/company/verification"
          element={<ProtectedRoute allowedRoles={['employer']}><CompanyVerification /></ProtectedRoute>}
        />
        <Route
          path="/analytics/hiring"
          element={<ProtectedRoute allowedRoles={['employer']}><HiringAnalytics /></ProtectedRoute>}
        />
        <Route
          path="/analytics/job"
          element={<ProtectedRoute allowedRoles={['employer']}><JobAnalytics /></ProtectedRoute>}
        />
             <Route
          path="/analytics/candidates"
          element={<ProtectedRoute allowedRoles={['employer']}><CandidateAnalytics /></ProtectedRoute>}
        />

        <Route
  path="/employer/jobs/:jobId/database"
  element={<ProtectedRoute allowedRoles={['employer']}><EmployerCandidateDatabase /></ProtectedRoute>}
/>
<Route
  path="/employer/candidates/:candidateId"
  element={<ProtectedRoute allowedRoles={['employer']}><EmployerCandidateProfile /></ProtectedRoute>}
/>

<Route
  path="/employer/reports"
  element={<ProtectedRoute allowedRoles={['employer']}><EmployerReports /></ProtectedRoute>}
/>

<Route
  path="/employer/fraud-flags"
  element={<ProtectedRoute allowedRoles={['employer']}><FraudFlags /></ProtectedRoute>}
/>

<Route
  path="/employer/placements"
  element={<ProtectedRoute allowedRoles={['employer']}><EmployerPlacements /></ProtectedRoute>}
/>

<Route
  path="/employer/retentions"
  element={<ProtectedRoute allowedRoles={['employer']}><EmployerRetentions /></ProtectedRoute>}
/>

<Route
  path="/agent/employers/:id"
  element={<ProtectedRoute allowedRoles={['agent']}><AgentEmployerDetail /></ProtectedRoute>}
/>

<Route
  path="/employer/database"
  element={<ProtectedRoute allowedRoles={['employer']}><EmployerDatabase /></ProtectedRoute>}
/>

<Route
  path="/employer/helpsupport"
  element={<ProtectedRoute allowedRoles={['employer']}><EmployerHelpSupport /></ProtectedRoute>}
/>



       

        {/* ---------------- Agent routes ---------------- */}
        <Route
          path="/agent/dashboard"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentDashboard /></ProtectedRoute>}
        />
        <Route
          path="/agent/candidates"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentCandidates /></ProtectedRoute>}
        />
        <Route
          path="/agent/employers"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentEmployers /></ProtectedRoute>}
        />
        <Route
          path="/agent/jobs"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentJobsList /></ProtectedRoute>}
        />
        <Route
          path="/agent/follow-ups"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentFollowUps /></ProtectedRoute>}
        />
        <Route
          path="/agent/interviews"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentInterviews /></ProtectedRoute>}
        />
        <Route
          path="/agent/reports"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentReports /></ProtectedRoute>}
        />
        <Route
          path="/agent/settings"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentSettings /></ProtectedRoute>}
        />
        <Route
          path="/agent/commissions"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentCommissions /></ProtectedRoute>}
        />

        <Route
          path="/agent/subscriptions"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentSubscriptions /></ProtectedRoute>}
        />

          <Route
          path="/agent/expiring-plans"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentExpiringPlans /></ProtectedRoute>}
        />

        <Route
          path="/agent/verification"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentVerification /></ProtectedRoute>}
        />
        <Route
          path="/agent/verification/:id"
          element={<ProtectedRoute allowedRoles={['agent']}><AgentVerificationDetail /></ProtectedRoute>}
        />
<Route
  path="/agent/support-tickets"
  element={<ProtectedRoute allowedRoles={['agent']}><AgentSupportTicketsPanel /></ProtectedRoute>}
/>

<Route
  path="/agent/aggregated-applications"
  element={<ProtectedRoute allowedRoles={['agent']}><AgentAggregatedApplications /></ProtectedRoute>}
/>


<Route 
path="/agent/employers/:id/jobs/new"
 element={<ProtectedRoute allowedRoles={['agent']}><AgentPostJob /></ProtectedRoute>}
 />

<Route path="/agent/businesses" element={<AgentBusinesses />} />

<Route
  path="/agent/business-follow-ups"
  element={<ProtectedRoute allowedRoles={['agent']}><BusinessFollowUpsPage /></ProtectedRoute>}
/>
        {/* ---------------- Admin routes ---------------- */}
        <Route
          path="/admin"
          element={<ProtectedRoute allowedRoles={['admin']}><AdminPanel /></ProtectedRoute>}
        />

        <Route
          path="/admin/verification"
          element={<ProtectedRoute allowedRoles={['admin']}><AdminVerification /></ProtectedRoute>}
        />
        <Route
          path="/admin/verification/:id"
          element={<ProtectedRoute allowedRoles={['admin']}><AdminVerificationDetail /></ProtectedRoute>}
        />
        <Route
          path="/admin/businesses"
          element={<ProtectedRoute allowedRoles={['admin']}><BusinessesPage /></ProtectedRoute>}
        />

                <Route
          path="/admin/enterprise-inquiries"
          element={<ProtectedRoute allowedRoles={['admin']}><div className="max-w-6xl mx-auto p-4"><AdminEnterpriseInquiries /></div></ProtectedRoute>}
        />
<Route
  path="/admin/support-tickets"
  element={<ProtectedRoute allowedRoles={['admin']}><AdminPanel initialTab="support-tickets" /></ProtectedRoute>}
/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;